import request from '@/utils/request'

const base = '/accounting/reports'

export const getDailyReport = params => request.get(`${base}/daily`, { params })

export const getProfitPosition = params => request.get(`${base}/profit-position`, { params })

export const getFinancialPosition = params => request.get(`${base}/financial-position`, { params })

export const financialPosition = getFinancialPosition

export const getProfitability = params => request.get(`${base}/profitability`, { params })

export const getProjectProfitability = params => request.get(`${base}/project-profitability`, { params })

export const getMonthlyPack = params => request.get(`${base}/monthly-pack`, { params })

export const getArAging = params => request.get(`${base}/ar-aging`, { params })

export const getContractStatus = params => request.get(`${base}/contract-status`, { params })

export const getSubcontractorBalances = params => request.get(`${base}/subcontractor-balances`, { params })

export const getCloseStatus = params => request.get(`${base}/close-status`, { params })

export const getEmployeeReport = (userId, params) => request.get(`${base}/employees/${userId}`, { params })

export const getMyDailyReport = params => request.get('/me/reports/daily', { params })

export const getMyMonthlyReport = params => request.get('/me/reports/monthly', { params })
